<template>
  <v-btn
    small
    icon
    color="grey darken-2"
    @click="$emit('click')"
  >
    <v-icon small>mdi-trash-can-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'TrashButton',
};
</script>

<style scoped>

</style>
